(ns app.domain.party-role.time-travel
  "Utilities for operating with party roles whose role attributes may be deprecated by Datomic time travel,
   i.e. `datomic.api/as-of`"
  (:require [app.domain.business.model :as business-model]
            [core.db.entity.util :as eu]))


(defn party-role-keys
  "Old parties may have deprecated :party/roles attribute"
  [party]
  (or (some->> party :party/party-roles seq (map :party-role/key) set)
      (some->> party :party/roles seq set)))


(defn party-has-role?
  "Old parties may have deprecated :party/roles attribute"
  [party role-key]
  (contains? (party-role-keys party) role-key))


(defn parties-for-user
  "Returns the parties of `application` that `user` controls and that have one or more of the roles in
  `expected-keyword-roles` set."
  [user application expected-keyword-roles]
  {:pre [(coll? expected-keyword-roles)]}
  (->> application
       ;; Old applications might not have the tuple index, so need to use :entity/_parent to support time-travel
       :entity/_parent
       (filter #(and (eu/is-type? :entity.type/party %)
                     (or (some-> % :party/user (= user))
                         (some-> % :party/business (business-model/user-is-member? user)))
                     (some (set expected-keyword-roles) (party-role-keys %))))))


(defn declaration-config-role-key
  "Old declaration configs may have deprecated :declaration-config/role attribute"
  [declaration-config]
  (or (-> declaration-config :declaration-config/party-role :party-role/key)
      (-> declaration-config :declaration-config/role)))


(defn required-sign-off-role-keys
  "Old group configs may have deprecated :group.config/sign-off-required-roles attribute"
  [group-config]
  (or (some->> group-config :group.config/sign-off-required-party-roles (map :party-role/key) seq set)
      (some->> group-config :group.config/sign-off-required-roles seq set)))
